import type { ItineraryCustomizationInfo } from "../../customization";
import { ItineraryCustomizationPanel } from "../ui/ItineraryCustomizationPanel";

type Props = {
  info?: ItineraryCustomizationInfo;
  loading: boolean;
  error: boolean;
};

/** 行程定制只读侧栏，与编辑页关联警告共享同一次查询结果。 */
export function ItineraryCustomizationInfoPage({ info, loading, error }: Props) {
  return (
    <ItineraryCustomizationPanel
      title={info?.title ?? undefined}
      rows={info?.rows ?? []}
      loading={loading}
      error={error}
    />
  );
}
